import React, { useState } from "react";

import Button from "../elements/button";
import Loading from "../loading";

export default function DeletePopup({
  handleConfirmDeleteDesignation,
  handleConfirmDeleteUnit,
  unitToDelete,

  loading,

  setUnitToDelete,
  // opciono: drugi korak potvrde sa sopstvenim tekstom i nazivima dugmadi;
  // bez ovih props-a ponašanje je nepromenjeno (Da / Ne)
  message,
  confirmLabel = "Da",
  cancelLabel = "Ne",
}) {
  return (
    <div className="link-popup">
      <p style={{ marginBottom: "20px" }}>
        {message || "Sigurno želite da obrišete?"}
      </p>
      <div className="link-popup-buttons">
        <Button
          onClick={() => {
            if (unitToDelete.key === "unit") {
              handleConfirmDeleteUnit(unitToDelete.payload);
            }
            if (unitToDelete.key === "designation") {
              handleConfirmDeleteDesignation(unitToDelete.payload);
            }
          }}
          title={confirmLabel}
          style={{
            backgroundColor: "white",
            color: "var(--mainColor)",
            border: "1px solid var(--mainColor)",
            fontWeight: "700",
            width: "120px",
          }}
        />
        <Button
          title={cancelLabel}
          style={{ width: "120px" }}
          onClick={() => {
            setUnitToDelete(null);
          }}
        />
      </div>
      <Loading isLoading={loading} />
    </div>
  );
}
